/**
 * PM megamenu — lazy images, intent preload, desktop keyboard navigation.
 */
window.theme = window.theme || {};

theme.PmMegamenu = (function () {
  var DEFER_SELECTOR = "img.pm-mm__defer-img";
  var FOCUSABLE_SELECTOR =
    'a[href], button:not([disabled]), summary, input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var loadedPanels = new WeakSet();

  function markLoaded(img) {
    img.classList.add("is-loaded");
  }

  function forceLoad(img) {
    if (img.classList.contains("is-loaded")) return;

    if (img.complete && img.naturalWidth > 0) {
      markLoaded(img);
      return;
    }

    img.addEventListener(
      "load",
      function () {
        markLoaded(img);
      },
      { once: true }
    );
    img.addEventListener(
      "error",
      function () {
        markLoaded(img);
      },
      { once: true }
    );

    if (img.loading === "lazy") {
      img.loading = "eager";
    }

    var src = img.currentSrc || img.getAttribute("src");
    if (src) {
      var loader = new Image();
      loader.src = src;
    }
  }

  function preloadPanel(container) {
    if (!container || loadedPanels.has(container)) return;
    loadedPanels.add(container);

    container.querySelectorAll(DEFER_SELECTOR).forEach(forceLoad);
  }

  function getFocusables(container) {
    return Array.prototype.filter.call(
      container.querySelectorAll(FOCUSABLE_SELECTOR),
      function (el) {
        return el.tabIndex !== -1 && !el.disabled && el.getAttribute("aria-hidden") !== "true";
      }
    );
  }

  function setPanelTabbability(panel, enabled) {
    panel.querySelectorAll("a[href], button:not([disabled]), summary").forEach(function (el) {
      if (enabled) {
        el.removeAttribute("tabindex");
      } else {
        el.setAttribute("tabindex", "-1");
      }
    });
  }

  function setDesktopExpanded(li, expanded) {
    var link = li.querySelector(":scope > a");
    if (link) {
      link.setAttribute("aria-expanded", expanded ? "true" : "false");
    }
  }

  function focusNextTopLevel(li) {
    var next = li.nextElementSibling;
    while (next) {
      var topLink = next.querySelector(":scope > a");
      if (topLink) {
        topLink.focus();
        return;
      }
      next = next.nextElementSibling;
    }
  }

  function initDesktop() {
    var nav = document.getElementById("siteNav");
    if (!nav || !nav.classList.contains("pm-nav-v2")) return;

    nav.querySelectorAll("li.lvl1.parent.megamenu").forEach(function (li) {
      var panel = li.querySelector(":scope > .megamenu");
      var link = li.querySelector(":scope > a");
      if (!panel || !link) return;

      link.setAttribute("aria-haspopup", "true");
      link.setAttribute("aria-expanded", "false");
      panel.setAttribute("aria-hidden", "true");
      setPanelTabbability(panel, false);

      var open = function () {
        li.classList.add("pm-mm--open");
        panel.setAttribute("aria-hidden", "false");
        setPanelTabbability(panel, true);
        setDesktopExpanded(li, true);
        if (panel.classList.contains("pm-mm-panel")) {
          preloadPanel(panel);
        }
      };

      var close = function (event) {
        if (event && event.type === "focusout" && li.contains(event.relatedTarget)) {
          return;
        }
        if (li.contains(document.activeElement)) {
          return;
        }
        li.classList.remove("pm-mm--open");
        panel.setAttribute("aria-hidden", "true");
        setPanelTabbability(panel, false);
        setDesktopExpanded(li, false);
      };

      link.addEventListener("keydown", function (e) {
        if (!li.classList.contains("pm-mm--open")) {
          if (e.key === "ArrowDown" || e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            open();
            var focusables = getFocusables(panel);
            if (focusables.length) {
              focusables[0].focus();
            }
          }
          return;
        }

        if (e.key === "Tab" && !e.shiftKey) {
          var items = getFocusables(panel);
          if (items.length) {
            e.preventDefault();
            items[0].focus();
          }
        }

        if (e.key === "ArrowDown") {
          e.preventDefault();
          var downItems = getFocusables(panel);
          if (downItems.length) {
            downItems[0].focus();
          }
        }
      });

      panel.addEventListener("keydown", function (e) {
        if (!li.classList.contains("pm-mm--open")) return;

        var items = getFocusables(panel);
        if (!items.length) return;

        var first = items[0];
        var last = items[items.length - 1];
        var current = document.activeElement;

        if (e.key === "Tab" && e.shiftKey && current === first) {
          e.preventDefault();
          link.focus();
        }

        if (e.key === "Tab" && !e.shiftKey && current === last) {
          e.preventDefault();
          focusNextTopLevel(li);
        }

        if (e.key === "Escape") {
          e.preventDefault();
          link.focus();
        }
      });

      li.addEventListener("mouseenter", open, { passive: true });
      li.addEventListener("mouseleave", function () {
        if (li.contains(document.activeElement)) return;
        close();
      });
      li.addEventListener("focusin", open);
      li.addEventListener("focusout", close);

      panel.addEventListener(
        "wheel",
        function (e) {
          if (!li.classList.contains("pm-mm--open") && !li.matches(":hover")) {
            return;
          }

          var scrollable = panel.scrollHeight > panel.clientHeight + 1;
          if (!scrollable) {
            e.preventDefault();
            return;
          }

          var atTop = panel.scrollTop <= 0;
          var atBottom =
            panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 1;

          if ((e.deltaY < 0 && atTop) || (e.deltaY > 0 && atBottom)) {
            e.preventDefault();
          }
        },
        { passive: false }
      );
    });
  }

  function init() {
    initDesktop();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  return {
    preloadPanel: preloadPanel,
  };
})();
